module.exports = __webpack_public_path__ + "img/empty-card.46135642.svg";